import { mapGetters, mapActions } from "vuex";
import EventBus from "@/event-bus";


export default {
    
    /*-------------------------
        Datas
    ---------------------------*/
    data() {
        return {
            displayMobileFirstPage: true,
            toLeadForm: false,
            exitPageContent: "",
            pages: {
                tunnel: false,
                exit: false,
                resume: false 
            },
            tunnelForm: {
                name: "dwelling",
                questionIndex: 0,
            },
        };
    },

    /*-------------------------
        Computed
    ---------------------------*/
    computed: {
        ...mapGetters({ 
            dwellingAnswers: "getDwellingStepAnswers",
            currentStep: "getCurrentStep",
        }),
    },

    /*-------------------------
        Methods
    ---------------------------*/
    methods: {

        /**
         * Navigate to step
         * @param {String} step 
         */
        _navigateToStep(step) {
            switch (step) {
                case "save_energy":
                    this._displayPage("resume")
                    break;
                case "dwelling" || "aids":
                    this.toLeadForm=false;
                    this._displayTunnelForm(step)
                    break;
                default:
                    break;
            }
        },

        /**
         * toggle pages
         * @param {String} pageToDisplay - [tunnel, exit, resume]
         * @param {String} exitPageContent - [aids_failure, zipcode_failure, midStep, success]
         */
        _displayPage(pageToDisplay, exitPageContent = "success") {
            //If exit page, handle content to display
            this.exitPageContent = exitPageContent;
            
            Object.keys(this.pages).forEach(pageName => {
                pageName === pageToDisplay ? this.pages[pageName] = true : this.pages[pageName] = false;
            })
        },

        /**
         * Toggle forms and handle currentQuestion
         * @param {String} name - [dwelling, aids]
         * @param {number} index - question index to start
         */
        _displayTunnelForm(name, index=0) {
            this.tunnelForm.name = name;
            this.tunnelForm.questionIndex = index;
            
            this._displayPage('tunnel')
        },

        /**
         * Got to leadForm back from DiagnosticPage
         */
        _displayLeadForm() {
            // last question responded before leadForm
            const lastQuestionResponded = Object.keys(this.dwellingAnswers).length-2;
            
            this.toLeadForm = true;
            this._displayTunnelForm("dwelling", lastQuestionResponded)
        },
        

        /**
         * Map Actions
         */
        ...mapActions([
            "setCurrentStep",
            "setValideStep"
        ])
    },

    /*-------------------------
        Created
    ---------------------------*/
    created() {
        //Listen page to display
        EventBus.$on("simulator-page::exit", (exitContent) => this._displayPage("exit", exitContent));
        EventBus.$on("simulator-page::resume", () => this._displayPage("resume"));
        EventBus.$on("simulator-page::tunnel", (formName, index=0) => this._displayTunnelForm(formName, index));
        EventBus.$on("simulator-page::statut-question", (form)=> this._displayTunnelForm(form))

        //Listen display lead form
        EventBus.$on('tunnel-leadForm::display', ()=> this._displayLeadForm());

        //Listen step to validate
        EventBus.$on("stepAction::validate", (step) => this.setValideStep(step));

        //Listen current step
        EventBus.$on("stepAction::current", (step) => this.setCurrentStep(step));
    },

    /*-------------------------
        Watch
    ---------------------------*/
    watch: {
        currentStep(newValue, oldValue) {
            this._navigateToStep(newValue)
        },
    },
    
};
